export interface ISocialNet {
    code:
        | 'vk'
        | 'youtube'
        | 'telegram'
        | 'messenger'
        | 'phone'
        | 'ok'
        | 'appstore'
        | 'googleplay'
        | 'rustore'
        | 'huawei'
        | 'max';
    link: string | null;
    targetBlank: boolean;
    svgUrl: string;
    type: number;
}

export interface ISocialNetsResponse {
    items: ISocialNet[];
}

export enum SocialNetType {
    Share = 166,
    Social = 167,
    Contact = 168,
}
